import { useState } from "react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Head from "../../../../Components/Head";
import { useColumns } from "./useColumns";
import styleWebUrls from "./WebUrls.module.css";
import { useGetWebUrlsList } from "../../../../api/webUrls";

const WebUrls = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [filters, setFilters] = useState({ name: "" });
  const { data, isLoading, isFetching, isError, error, refetch } =
    useGetWebUrlsList({ limit, offset, ...filters });
  const { columns } = useColumns(refetch);

  const handleSearch = () => {
    setOffset(0);
    setFilters({
      name: name,
    });
  };

  const dataWithKeys = data?.data?.map((webUrl, index) => ({
    ...webUrl,
    key: webUrl?.id,
    sn: offset + (index + 1),
  }));

  const onChange = pagination => {
    setLimit(pagination?.pageSize);
    setOffset((pagination?.current - 1) * pagination?.pageSize);
  };

  return (
    <main className={styleWebUrls["web-urls-main-container"]}>
      <Head title="Web URLs" />
      <div className={styleWebUrls["web-urls-form"]}>
        <div className={styleWebUrls["web-urls-input-go-btn-container"]}>
          <input
            type="text"
            placeholder="Search by Name"
            onChange={event => {
              setName(event.target.value);
            }}
          />
          <button onClick={handleSearch}>Go</button>
        </div>
        <div className={styleWebUrls["add-web-urls"]}>
          <button onClick={() => navigate("/web-twinprocms/web-urls/create")}>
            <FontAwesomeIcon icon={faPlus} /> Add Web URL
          </button>
        </div>
      </div>
      {isError && <p>{error?.message}</p>}
      <div className={styleWebUrls["web-urls-table-container"]}>
        <Table
          rowClassName="cursor-pointer"
          columns={columns}
          dataSource={dataWithKeys}
          onChange={onChange}
          loading={isLoading || isFetching}
          pagination={{ total: data?.total, showSizeChanger: true }}
        />
      </div>
    </main>
  );
};

export default WebUrls;